import { OnInit, Component, forwardRef, Input } from '@angular/core'
import { ServiceObject } from "app/models/serviceObject";
import { Asset } from "app/models/asset";

@Component({
  selector: 'serviceObject-tree-node',
  templateUrl: './serviceObject-tree-node.component.html',
  styleUrls: ['./serviceObject-tree-node.component.scss']
})
export class ServiceObjectTreeNodeComponent {
  @Input("node")
  public node: ServiceObject;

  @Input("selectedNodeId")
  public selectedNodeId: number;

  private isAsset(serviceObject: ServiceObject) {
    return serviceObject instanceof Asset;
  }
}



// WEBPACK FOOTER //
// /app/SPA/src/app/client/components/serviceObject/tree-node/serviceObject-tree-node.component.ts